export default __webpack_public_path__ + "static/media/TheElectricCar_05.437f0980.png";